import type { JSX, ReactNode } from 'react';
import { PortalHeader } from '@cca/ui';
import { useInstance } from '../frame/InstanceContext';

/** Chrome for the unauthenticated auth pages: org-standard header + centred body. */
export function AuthFrame({ children }: { children: ReactNode }): JSX.Element {
  const { instanceName } = useInstance();
  return (
    <div className="app">
      <PortalHeader portalName={instanceName} toolName="Corpus" />
      <div className="auth-body">{children}</div>
      <footer className="app-footer">CCAANZ Corpus · {new Date().getFullYear()}</footer>
    </div>
  );
}
